import { jsx as l } from "react/jsx-runtime";
import c from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as m } from "react";
const a = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 7 20 18", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M23.035 25H8.987a2.94 2.94 0 0 1-2.645-1.611c-.456-.854-.456-1.991 0-2.844l7.024-12.038c.912-1.517 2.828-1.991 4.287-.948.365.284.73.568.913.948l7.024 12.038c.547.853.547 1.99 0 2.844C25.133 24.43 24.13 25 23.035 25m-7.102-4a.933.933 0 1 1 0-1.867.933.933 0 0 1 0 1.867m0-2.427c.31 0 .56-.251.56-.56l.374-4.08a.934.934 0 0 0-1.867 0l.373 4.08c0 .31.25.56.56.56", clipRule: "evenodd" })), f = /* @__PURE__ */ m(({ size: e = "inherit", sx: o, ...n }, r) => {
  const i = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ l(c, {
    ...n,
    ref: r,
    component: a,
    inheritViewBox: !0,
    sx: i
  });
});
f.displayName = "svg_warning";
export {
  f as default
};
